import React, { useEffect } from 'react';
import { Layout, Space, Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { BookOutlined, ShareAltOutlined } from '@ant-design/icons';
import UserInfoCard from '../components/UserInfoCard';
import ConfigurationsSection from '../components/ConfigurationsSection';
import { useApp } from '../context/AppContext';

const { Content } = Layout;

const HomePage = ({ telegramTheme, isTelegramAvailable }) => {
  const navigate = useNavigate();
  
  // Используем контекст для получения данных пользователя и темы
  const { 
    user, 
    isAuthenticated, 
    loadingStates,
    t
  } = useApp();

  // Настраиваем MainButton
  useEffect(() => {
    if (isTelegramAvailable && window.Telegram?.WebApp?.MainButton) {
      try {
        const backButton = window.Telegram.WebApp.BackButton;
        if (backButton) {
          backButton.hide();
        }

        const mainButton = window.Telegram.WebApp.MainButton;
        
        // Настраиваем MainButton
        mainButton.setText(t('home_add_key'));
        mainButton.show();
        
        // Настраиваем обработчик клика
        const handleMainButtonClick = () => {
          navigate('/purchase-key');
        };

        mainButton.onClick(handleMainButtonClick);

        if (user?.is_admin) {
          const secondaryButton = window.Telegram.WebApp.SecondaryButton;
          secondaryButton.setText(t('home_admin_panel'));
          secondaryButton.show();
          secondaryButton.onClick(() => {
            navigate('/admin');
          });
    
          return () => {
            secondaryButton.offClick(() => {
              navigate('/admin');
            });
            secondaryButton.hide();

            mainButton.offClick(handleMainButtonClick);
            mainButton.hide();
          };
        }

        // Cleanup function
        return () => {
          try {
            mainButton.offClick(handleMainButtonClick);
            mainButton.hide();
          } catch (error) {
            console.warn('Ошибка при скрытии MainButton:', error);
          }
        };
      } catch (error) {
        console.warn('Ошибка при настройке MainButton:', error);
      }
    }    
  }, [navigate, isTelegramAvailable, t, user?.is_admin]);

  // Показываем загрузку пока данные пользователя не получены
  if (loadingStates.user || !isAuthenticated) {
    return (
      <Layout>
        <Content style={{ padding: '16px', textAlign: 'center' }}>
          <Space direction="vertical" size="large">
            <div>{t('home_loading')}</div>
          </Space>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout>
      <Content style={{ padding: '16px' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          
          {/* Блок с информацией о пользователе */}
          <UserInfoCard 
            user={user}
            isTelegramAvailable={isTelegramAvailable}
          />

          <Button type="primary" size="large" icon={<ShareAltOutlined />} onClick={() => navigate('/referral')} style={{ width: '100%' }}>{t('home_referral_btn')}</Button>

          {/* Кнопка для перехода к инструкции */}
          <Card>
            <Button 
              type="secondary" 
              size="large" 
              icon={<BookOutlined />}
              onClick={() => navigate('/vpn-instruction')}
              style={{ 
                width: '100%',
                fontWeight: '500'
              }}
            >
              {t('home_instruction_btn')}
            </Button>
          </Card>

          {/* Секция конфигураций */}
          <ConfigurationsSection />

        </Space>
      </Content>
    </Layout>
  );
};

export default HomePage;
